module.exports = __webpack_public_path__ + "static/media/novarc-logo.white.b8f58f70.svg";